var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassPanel", {
    ref: "cardsPanel",
    staticClass: "cards-settings-panel",
    attrs: {
      value: true,
      size: "small",
      title: _vm.dashboardManagementLabel,
      "primary-action": _vm.primaryAction,
      "secondary-actions": _vm.secondaryActions
    },
    on: {
      beforeClose: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "flex-row ai-center jc-space" },
              [
                _c(
                  "div",
                  { staticClass: "typographies-paragraph-large-semibold" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Afficher / Masquer les cartes")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("CardCounter", {
                  staticClass: "m-0",
                  attrs: { current: _vm.cards.length, max: _vm.max }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasReportsAccess
              ? _c(
                  "CompassTabs",
                  {
                    model: {
                      value: _vm.selectedTab,
                      callback: function($$v) {
                        _vm.selectedTab = $$v
                      },
                      expression: "selectedTab"
                    }
                  },
                  [
                    _c(
                      "CompassTabPane",
                      {
                        attrs: {
                          label: _vm.$t.__("dashboard.CardsSettingsPanel.card"),
                          name: "cards"
                        }
                      },
                      [
                        !!_vm.cardsCrm.length
                          ? _c(
                              "CompassCheckboxGroup",
                              {
                                attrs: {
                                  label: _vm.$t.__(
                                    "dashboard.CardsSettingsPanel.crm"
                                  )
                                }
                              },
                              _vm._l(_vm.cardsCrm, function(card) {
                                return _c("CompassCheckbox", {
                                  key: card.type,
                                  ref: "cardsCheckboxCrm",
                                  refInFor: true,
                                  attrs: {
                                    "model-value": card.label,
                                    checked: _vm.isActiveCard(card.type),
                                    disabled: _vm.disabledCard(card.type)
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.checkCard(card)
                                    }
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !!_vm.cardsInvoicing.length
                          ? _c(
                              "CompassCheckboxGroup",
                              {
                                staticClass: "mt-3",
                                attrs: {
                                  label: _vm.$t.__(
                                    "dashboard.CardsSettingsPanel.invoicing"
                                  )
                                }
                              },
                              _vm._l(_vm.cardsInvoicing, function(card) {
                                return _c("CompassCheckbox", {
                                  key: card.type,
                                  ref: "cardsCheckboxInvoicing",
                                  refInFor: true,
                                  attrs: {
                                    "model-value": card.label,
                                    checked: _vm.isActiveCard(card.type),
                                    disabled: _vm.disabledCard(card.type)
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.checkCard(card)
                                    }
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !!_vm.cardsAccounting.length
                          ? _c(
                              "CompassCheckboxGroup",
                              {
                                staticClass: "mt-3",
                                attrs: {
                                  label: _vm.$t.__("common.labels.accounting")
                                }
                              },
                              _vm._l(_vm.cardsAccounting, function(card) {
                                return _c("CompassCheckbox", {
                                  key: card.type,
                                  ref: "cardsCheckboxAccounting",
                                  refInFor: true,
                                  attrs: {
                                    "model-value": card.label,
                                    checked: _vm.isActiveCard(card.type),
                                    disabled: _vm.disabledCard(card.type)
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.checkCard(card)
                                    }
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "CompassTabPane",
                      {
                        attrs: {
                          label: _vm.$t.__("common.labels.reports"),
                          name: "reports"
                        }
                      },
                      [
                        _vm.reportCardLimit !== true
                          ? _c("CompassAlert", {
                              attrs: {
                                description: _vm.$t.__(
                                  "dashboard.CardsSettingsPanel.can_add_up_to_x_reports_tiles",
                                  {
                                    reportCardLimit: _vm.reportCardLimit
                                  }
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("CompassInput", {
                          staticClass: "flex-row ai-center wp-10",
                          attrs: {
                            placeholder: _vm.searchReportPlaceholderLabel,
                            "suffix-icon": "search"
                          },
                          model: {
                            value: _vm.searchInput,
                            callback: function($$v) {
                              _vm.searchInput = $$v
                            },
                            expression: "searchInput"
                          }
                        }),
                        _vm._v(" "),
                        !!_vm.cardsReportProspecting.length
                          ? _c(
                              "CompassCheckboxGroup",
                              {
                                staticClass: "mt-3",
                                attrs: {
                                  label: _vm.getLicenceLabel(
                                    "pack_prospecting_sale"
                                  )
                                }
                              },
                              _vm._l(_vm.cardsReportProspecting, function(
                                card
                              ) {
                                return _c(
                                  "div",
                                  { key: card.type, staticClass: "container" },
                                  [
                                    _c("CompassCheckbox", {
                                      key: card.type,
                                      ref: "cardsCheckboxReportProspecting",
                                      refInFor: true,
                                      attrs: {
                                        "model-value": card.label,
                                        checked: _vm.isActiveCard(card.type),
                                        disabled:
                                          _vm.disabledCard(card.type) ||
                                          card.has_to_upgrade
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.checkCard(card)
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    card.has_to_upgrade
                                      ? _c(
                                          "CompassTooltip",
                                          {
                                            attrs: {
                                              placement: "bottom-end",
                                              content: _vm.getUpsellTooltip,
                                              "content-class": "badge-tooltip"
                                            }
                                          },
                                          [
                                            _c("CompassFeatureBadge", {
                                              staticClass: "badge",
                                              attrs: {
                                                variant: "upsell",
                                                size: "small"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !!_vm.cardsReportInvoicing.length
                          ? _c(
                              "CompassCheckboxGroup",
                              {
                                staticClass: "mt-3",
                                attrs: {
                                  label: _vm.getLicenceLabel(
                                    "pack_invoicing_management"
                                  )
                                }
                              },
                              _vm._l(_vm.cardsReportInvoicing, function(card) {
                                return _c(
                                  "div",
                                  { key: card.type, staticClass: "container" },
                                  [
                                    _c("CompassCheckbox", {
                                      key: card.type,
                                      ref: "cardsCheckboxReportInvoicing",
                                      refInFor: true,
                                      staticClass: "container",
                                      attrs: {
                                        "model-value": card.label,
                                        checked: _vm.isActiveCard(card.type),
                                        disabled:
                                          _vm.disabledCard(card.type) ||
                                          card.has_to_upgrade
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.checkCard(card)
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    card.has_to_upgrade
                                      ? _c(
                                          "CompassTooltip",
                                          {
                                            attrs: {
                                              placement: "bottom-end",
                                              content: _vm.getUpsellTooltip,
                                              "content-class": "badge-tooltip"
                                            }
                                          },
                                          [
                                            _c("CompassFeatureBadge", {
                                              staticClass: "badge",
                                              attrs: {
                                                variant: "upsell",
                                                size: "small"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "mt-4 pt-1" },
                  [
                    !!_vm.cardsCrm
                      ? _c(
                          "CompassCheckboxGroup",
                          {
                            attrs: {
                              label: _vm.$t.__(
                                "dashboard.CardsSettingsPanel.crm"
                              )
                            }
                          },
                          _vm._l(_vm.cardsCrm, function(card) {
                            return _c("CompassCheckbox", {
                              key: card.type,
                              ref: "cardsCheckboxCrm",
                              refInFor: true,
                              attrs: {
                                "model-value": card.label,
                                checked: _vm.isActiveCard(card.type),
                                disabled: _vm.disabledCard(card.type)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.checkCard(card)
                                }
                              }
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !!_vm.cardsInvoicing
                      ? _c(
                          "CompassCheckboxGroup",
                          {
                            staticClass: "mt-3",
                            attrs: {
                              label: _vm.$t.__(
                                "dashboard.CardsSettingsPanel.invoicing"
                              )
                            }
                          },
                          _vm._l(_vm.cardsInvoicing, function(card) {
                            return _c("CompassCheckbox", {
                              key: card.type,
                              ref: "cardsCheckboxInvoicing",
                              refInFor: true,
                              attrs: {
                                "model-value": card.label,
                                checked: _vm.isActiveCard(card.type),
                                disabled: _vm.disabledCard(card.type)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.checkCard(card)
                                }
                              }
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !!_vm.cardsAccounting
                      ? _c(
                          "CompassCheckboxGroup",
                          {
                            staticClass: "mt-3",
                            attrs: {
                              label: _vm.$t.__("common.labels.accounting")
                            }
                          },
                          _vm._l(_vm.cardsAccounting, function(card) {
                            return _c("CompassCheckbox", {
                              key: card.type,
                              ref: "cardsCheckboxAccounting",
                              refInFor: true,
                              attrs: {
                                "model-value": card.label,
                                checked: _vm.isActiveCard(card.type),
                                disabled: _vm.disabledCard(card.type)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.checkCard(card)
                                }
                              }
                            })
                          }),
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }